import Component from '~/components/component';
import EventEmitter from 'eventemitter3';
import { MANAGE_MAP_EVENT } from "../../helpers/map-manager";
import { MANAGE_COLLABORATOR_EVENT } from "../collaborators-groups/collaborators-groups";

export default class Menu extends Component {
	constructor(...args) {
		super(...args);

		// if( ENV.device == 'mobile' || ENV.device == 'tablet' ) {
			this._manageMenuBurger = new ManageMenuBurger({
				component : this.dom.component
			})
		// }
	}

	_retrieveDOM(){
		this.dom.navbar = document.body.querySelector('.js-navbar');

		/** Check if we need to disable transparent navbar on header **/
		this._enableBackground = document.querySelector('.ct--header') || false;
		if( this._enableBackground == false )
			this.dom.navbar.classList.add('enabled');
		else
			this.animated = true;
	}
	
	bind() {
		super.bind();

		this.on( MANAGE_MAP_EVENT.CLICK_PIN, () => {
			// if( ENV.device != "desktop" )
				this._manageMenuBurger._hideComponent();
		} );
		this.on( MANAGE_MAP_EVENT.CLOSE_POPUP, () => {
			// if( ENV.device != "desktop" )
				this._manageMenuBurger._showComponent()
		} );

		this.on( MANAGE_COLLABORATOR_EVENT.OPEN_POPIN, () => {
			// if( ENV.device != "desktop" )
				this._manageMenuBurger._hideComponent();
			// else
				this._hideComponent();
		} );
		this.on( MANAGE_COLLABORATOR_EVENT.CLOSE_POPIN, () => {
			// if( ENV.device != "desktop" )
				this._manageMenuBurger._showComponent();
			// else
				this._showComponent();
		} );
	}

	_toggleBackground() {
		if( window.pageYOffset > 0 && window.pageYOffset > this._enableBackground.getBoundingClientRect().height) {
			this.dom.navbar.classList.add('enabled');
		}
		else {
			this.dom.navbar.classList.remove('enabled');
		}
	}

	_hideComponent() {
		this.dom.component.classList.add('hide-component');
	}

	_showComponent() {
		this.dom.component.classList.remove('hide-component');
	}

	_update( pos ) {

		if( this._enableBackground ) {
			this._toggleBackground();
		}
	}

	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}

class ManageMenuBurger {

	_currentScroll = 0;
	_is_open = false;

	constructor( { component } ) {

		this.dom = {};
		this.dom.component = document.body.querySelector('.ct--menu-mobile');

		this._retrieveDOM();
		this._show();
		this._bind();
	}

	_retrieveDOM() {

		this.dom.navbar = document.body.querySelector('.js-navbar');
		this.dom.cta = document.body.querySelector('.js-menu-burger');
		this.dom.showChildren = document.body.querySelectorAll('.js-has-children');
		this.dom.showOthers = document.body.querySelector('.js-show-other-websites');
		this.dom.wrapperOthers = document.body.querySelector('.js-list-others-websites');
		this.dom.labelChildren = document.body.querySelectorAll('.js-has-children');
		this.dom.containerChildren = document.body.querySelectorAll('.js-menu-subitems');
	}

	_show() {
		this.dom.navbar.classList.add('show');
	}

	_bind() {
		this.dom.cta.addEventListener('click', () => {
			( this.dom.cta.classList.contains('active') ) ? this._closeMenu() : this._openMenu();
		});
		this.dom.showOthers.addEventListener('click', ()=>{
			if (!this.dom.wrapperOthers.classList.contains('open')) {
				this.dom.wrapperOthers.classList.add('open');
				this.dom.showOthers.classList.add('open');
			} else {
				this.dom.wrapperOthers.classList.remove('open');
				this.dom.showOthers.classList.remove('open');
			}
		})

		this.dom.showChildren.forEach(elementHasChildren => {
			elementHasChildren.addEventListener('click', () => {
				if (!elementHasChildren.classList.contains('open')) {
					elementHasChildren.classList.add('open');
				} else {
					elementHasChildren.classList.remove('open');
				}
			})
		});
	}

	_openMenu() {
		if( this._is_open == false ) {
			// Prevent scroll
			this._currentScroll = window.pageYOffset;
			document.body.classList.add('no-scroll');
			this.dom.navbar.classList.add('open');

			// Remove navbar bg
			// this.dom.navbar.classList.remove('enabled');

			// Open menu
			this.dom.component.classList.add('open');
			this.dom.cta.classList.add('active');
			this._is_open = true;
		}
	}

	_closeMenu() {
		if( this._is_open == true ) {
			// Enable scroll
			document.body.classList.remove('no-scroll');
			this.dom.navbar.classList.remove('open');
			if( ENV.template == 'mobile' ) {
				TweenMax.set(window, { scrollTo: { y: this._currentScroll } });
			}
			// Manage navbar bg
			if( this._enableBackground == false )
				this.dom.navbar.classList.add('enabled');
			// Close menu
			this.dom.component.classList.remove('open');
			this.dom.cta.classList.remove('active');
			this._is_open = false;
		}
	}

	_showComponent() {
		this.dom.navbar.classList.remove('hide-component');
		this.dom.component.classList.remove('hide-component');
	}

	_hideComponent() {
		this.dom.navbar.classList.add('hide-component');
		this.dom.component.classList.add('hide-component');
	}
}



// WEBPACK FOOTER //
// src/js/components/menu/menu.js